import { useCallback, useState } from 'react'

const STORAGE_KEY = 'selected_model_id'

export function useSelectedModel(fallbackModelId?: string) {
  const [selectedModelId, setSelectedModelId] = useState<string | undefined>(() => {
    return localStorage.getItem(STORAGE_KEY) || undefined
  })

  const selectModel = useCallback((modelId: string | undefined) => {
    setSelectedModelId(modelId)
    if (modelId) {
      localStorage.setItem(STORAGE_KEY, modelId)
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }, [])

  const effectiveModelId = selectedModelId || fallbackModelId

  return { selectedModelId: effectiveModelId, selectModel }
}
